import { render } from "./Main.vue?vue&type=template&id=125dcb8e"
const script = {}
script.render = render

export default script